
import React from "react";
import AssinaturaPendente from "./Forms/AssinaturaPendente";
import PagamentoPendente from "./Forms/PagamentoPendente";

export function factory(_AChave, _AValor, _AProps = {}) {
    switch (_AChave) {
        case "ASSINATURA_PENDENTE": return <AssinaturaPendente data={_AValor} {..._AProps} />;
        case "PAGAMENTO_PENDENTE": return <PagamentoPendente data={_AValor} {..._AProps} />;
        case "ASSINATURA_UPGRADE": return <AssinaturaPendente data={_AValor} {..._AProps} />;
        default: return <React.Fragment></React.Fragment>;
    }
}
